import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import React, { FC } from 'react';

import { CloseIcon } from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';
import { ICommonPopupsProps, Popup, useClosePopupOnNavigation } from '@gem/popups';
import { Button, IconButton, IconView } from '@gem/ui-kit';

import { IllXlSecure } from 'APP/assets/illustrations';

import { useE2eeDisclaimerPopupPresenter } from './E2eeDisclaimerPopup.presenter';
import styles from './E2eeDisclaimerPopup.styles.m.css';

export const E2eeDisclaimerPopup: FC<ICommonPopupsProps> = observer((props) => {
  const { t } = useTranslation();
  const presenter = useE2eeDisclaimerPopupPresenter(props);
  useClosePopupOnNavigation(props.popupInstance);

  return (
    <Popup
      isOpened
      isHidden={props.popupInstance.isHidden}
      onClose={presenter.onClose}
      className={styles.popup}
    >
      <div className={classNames(styles.wrapper)}>
        <IconView
          Icon={IllXlSecure}
          className={styles.logo}
        />
        <IconButton
          Icon={CloseIcon}
          dataTest="close-popup"
          onClick={presenter.onClose}
          className={styles.closeIcon}
        />
        <h1 className={styles.title}>{t('secure_chat_onboarding_title')}</h1>
        <ul className={styles.list}>
          <li>{t('secure_chat_onboarding_description_a')}</li>
          <li>{t('secure_chat_onboarding_description_b')}</li>
          <li>{t('secure_chat_sync_requires_active_device_bullet')}</li>
          <li>{t('secure_chat_history_unavailable_banner')}</li>
        </ul>
        <Button
          onClick={presenter.onClose}
          size={'20'}
        >
          {t('secret_chat_oboarding_button')}
        </Button>
      </div>
    </Popup>
  );
});
